export default "__VITE_ASSET__6c6a03c1__"